import VoicesEngage from "../Components/Voices/Overview/VoicesEngage";

const VoicesEngagePage = () => {
  return <VoicesEngage />;
};

export default VoicesEngagePage;
